"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "@base-ui/react/tooltip";
import React from "react";
interface CustomTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
}
export function CustomTooltip(t0) {
  const $ = _c(15);
  const {
    children,
    content,
    side: t1
  } = t0;
  const side = t1 === undefined ? "top" : t1;
  const [container, setContainer] = React.useState(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const nav = document.getElementById("navbar-container");
      setContainer(nav || document.body);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  React.useEffect(t2, t3);
  const t4 = children as React.ReactElement;
  let t5;
  if ($[2] !== t4) {
    t5 = <Tooltip.Trigger render={t4}>{null}</Tooltip.Trigger>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== content) {
    t6 = <Tooltip.Popup className="tooltip-popup">{content}</Tooltip.Popup>;
    $[4] = content;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== side || $[7] !== t6) {
    t7 = <Tooltip.Positioner side={side} sideOffset={6}>{t6}</Tooltip.Positioner>;
    $[6] = side;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== container || $[10] !== t7) {
    t8 = <Tooltip.Portal container={container}>{t7}</Tooltip.Portal>;
    $[9] = container;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Tooltip.Provider delay={200}><Tooltip.Root>{t5}{t8}</Tooltip.Root></Tooltip.Provider>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}